import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=31ae54d6&"
import script from "./Book.vue?vue&type=script&lang=ts&"
export * from "./Book.vue?vue&type=script&lang=ts&"
import style0 from "./Book.vue?vue&type=style&index=0&id=31ae54d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports